export const ROLES = {
  SuperAdmin: "SuperAdmin",
  Admin: "Admin",
  NodalOfficer: "NodalOfficer"
};
